const { debounce } = window.BAO.Utils

class StickyScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!window.BAO.MediaBreakpoints.isSm) return

    this.setSticky()
  }

  setupListeners () {
    super.setupListeners()

    this.setSticky = this.setSticky.bind(this)
    this.debouncedResize = debounce(() => {
      this.setSticky()
    }, 240)
    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  setSticky () {
    if (!this.els?.container?.exists) return

    const containerHeight = this.els.container.element.offsetHeight
    const contentHeight = this.els.content.element.offsetHeight

    if (containerHeight > contentHeight && window.innerHeight < contentHeight) {
      this.classList.toggle('prd-Detail_Columns-bottomSticky', true)
    }
  }
}

if (!customElements.get('sticky-scroll')) {
  customElements.define('sticky-scroll', StickyScroll)
}
